import { render, staticRenderFns } from "./ImprimirAtividadeCrianca.vue?vue&type=template&id=bc72fd74"
import script from "./ImprimirAtividadeCrianca.vue?vue&type=script&lang=js"
export * from "./ImprimirAtividadeCrianca.vue?vue&type=script&lang=js"
import style0 from "./ImprimirAtividadeCrianca.vue?vue&type=style&index=0&id=bc72fd74&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports